module.exports = __webpack_public_path__ + "static/img/pad5.1fe9fe4c.png";